import {observer} from 'mobx-react-lite'
import React, {useEffect} from 'react'
import tw from 'tailwind-styled-components'
import {Lang} from 'yougile-lang'
import {Time} from 'yougile-util'
import {DateRangePicker} from '@components/common/date-picker/date-picker'
import {noPropagate} from '@containers/hooks'
import {
  StickerEditorState,
  StickerEditorStore,
  useStickerEditorStore
} from '../../sticker-editor-store'
import IconBeak from '../beak.svg'
import {getSprintInitValues} from './get-sprint-init-values'

const TwMenuHeader = tw.div`
  p-8
  border
  border-t-0
  border-l-0
  border-r-0
  border-solid
  bg-header-old
  leading-main
  text-main-old
  text-12
  border-main-old
`

const TwDateRangePicker = tw.div`
  overflow-hidden
  shadow-menu-old
  rounded-4
  bg-main-old
  border
  border-solid
  border-main-old
  w-max
  absolute
  top-0
  left-0
`

type ChooseIntervalProps = {
  store: StickerEditorStore
  state: StickerEditorState
  begin?: Date
  end?: Date
}

const chooseInterval = (props: ChooseIntervalProps) => {
  const {store, state, begin, end} = props
  const st = {
    ...state.sprintState,
    begin: Time.toTimestamp(begin),
    end: Time.toTimestamp(end)
  }
  store.setSprintState(st)
}

export const MenuDatePicker = observer(() => {
  const [state, store] = useStickerEditorStore()

  const {initialBegin, initialEnd} = getSprintInitValues(state)

  useEffect(() => {
    chooseInterval({store, state, begin: initialBegin, end: initialEnd})
  }, [state.sprintState?.id])

  const onChoose = (begin: Date, end: Date): void => {
    chooseInterval({store, state, begin, end})
  }

  return (
    <div className="relative z-50 mt-4" onMouseDown={noPropagate}>
      <div className="absolute z-10 -top-8 left-6">
        <IconBeak className="text-obscure-old" />
      </div>
      <div className="absolute z-10 -top-6 left-6">
        <IconBeak className="text-bg-header-old" />
      </div>
      <TwDateRangePicker>
        <TwMenuHeader>{Lang.msg.myStickers.ownDates}</TwMenuHeader>
        <DateRangePicker
          value={{start: initialBegin, end: initialEnd}}
          onChange={({start, end}): void => onChoose(start, end)}
        />
      </TwDateRangePicker>
    </div>
  )
})
